import { isNil } from 'lodash';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { EntityBatchField } from '@shared/data/entity/fields/EntityBatchField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';
import classNames from './EntityBatchCollectionViewField.module.css';

interface Props {
  field: EntityBatchField;
}

export function EntityBatchCollectionViewField({ field }: Props) {
  const schedule = field.refs.find(ref => ref.id === field.id);
  if (isNil(schedule)) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <View className={classNames.container}>
        <Text size="body1" className={classNames.text}>
          {schedule.name}
        </Text>
      </View>
    </CardCollectionViewFieldContainer>
  );
}
